import { render, staticRenderFns } from "./DashboardAlerts.vue?vue&type=template&id=e946760a&scoped=true&lang=pug"
import script from "./DashboardAlerts.vue?vue&type=script&lang=js"
export * from "./DashboardAlerts.vue?vue&type=script&lang=js"
import style0 from "./DashboardAlerts.vue?vue&type=style&index=0&id=e946760a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e946760a",
  null
  
)

export default component.exports